import * as JSONMapper from 'json-mapper';
import { JSONMapped, jsonProperty } from 'json-mapper-reflect';
import { Message } from '../common/message';
import { AvdbPricingProductCoverageDuration } from './avdb-pricing-product-coverage-duration';
import { AvdbPricingProductRegion } from './avdb-pricing-product-region';
import { AvdbPricingMapRegionID } from './avdb-pricing-map-region';
import { AvdbPricingProductRegionGeoCoverageType as CoverageType } from './avdb-pricing-product-region-geo-coverage';

export class AvdbPricingProductSeries extends JSONMapped() {
	@jsonProperty()
	id: number;

	@jsonProperty(JSONMapper.arrayOfClass(AvdbPricingProductCoverageDuration))
	coverageDurationOptions: Array<AvdbPricingProductCoverageDuration>;

	@jsonProperty(JSONMapper.classByMethods(AvdbPricingProductRegion))
	region: AvdbPricingProductRegion;

	@jsonProperty(JSONMapper.arrayOfClass(Message))
	messages: Array<Message>;

	@jsonProperty()
	customerComments: string;

	constructor(data?: Partial<AvdbPricingProductSeries>) {
		super();
		Object.assign(this, data);
	}

	get defaultCoverageDuration() {
		if (this.coverageDurationOptions == null)
			return null;
		return this.coverageDurationOptions[this.coverageDurationOptions.length - 1];
	}

	coversMapRegions(mapRegions: Array<AvdbPricingMapRegionID>, includeCompleteCoverageOnly: boolean): boolean {
		return mapRegions.every(mapRegionId => {
			const coverage = this.region.geoCoverage[mapRegionId];
			if (includeCompleteCoverageOnly) {
				return coverage === CoverageType.Complete;
			} else {
				return coverage === CoverageType.Complete || coverage === CoverageType.Partial;
			}
		});
	}
}
